export default {
    namespaced: true,

    state: () => ({
        publications: [],
        publication: {},
        dateRangeFilter: [{
            name: 'за всё время',
            dateRange: {
                from: '',
                to: ''
            }
        }]
    }),

    getters: {
        publications: state => state.publications,
        publication: state => state.publication,
        dateRangeFilter: state => state.dateRangeFilter,
    },

    actions: {
        loadPublications({commit}, {dateRange = {}, pageSize = 20} = {}) {
            return Promise.all([
                this.$api.getPublications(dateRange, pageSize),
            ]).then((publications) => {
                commit('setPublications', publications[0].content);
                commit('setFilter', publications[0].filters);
            })
        },

        loadPublicationPage({ rootState, commit }, { id = rootState.route.params.id } = {}) {
            return Promise.all([
                this.$api.getPublicationPage(id),
            ]).then((page) => {
                commit('setPublicationPage', page[0]);
            })
        }
    },

    mutations: {
        setPublications(state, payload) {
            state.publications = payload;
        },

        setPublicationPage(state, payload) {
            state.publication = payload;
        },

        setFilter(state, payload) {
            if (state.dateRangeFilter.length <= 1) {
                state.dateRangeFilter = state.dateRangeFilter.concat(payload);
            }
        }
    },
};
